import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/site/`,
		name: "添加场所",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/site/`,
		name: "删除场所",
		delete: async function(id,data){
			return await http.delete(this.url+id+"/", data);
		}
	},
    detail: {
		url: `${config.API_URL}/site/`,
		name: "查询场所详情",
		get: async function(id,data){
			return await http.get(this.url+id+"/", data);
		}
	},
    list: {
		url: `${config.API_URL}/site/`,
		name: "查询场所列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    update: {
		url: `${config.API_URL}/site/`,
		name: "修改场所",
		patch: async function(id,data){
			return await http.patch(this.url+id+"/", data);
		}
	},
    select:{
        url: `${config.API_URL}/searchSite/`,
		name: "下拉查询场所列表",
		get: async function(data, params){
			if(data != null && data != ""){
				return await http.get( this.url + data + "/",params);
			}else{
				return await http.get(this.url, params);
			}
		}
    },
    imageList:{
        url: `${config.API_URL}/siteImages/`,
		name: "查看场所图片",
		get: async function(id,data){
			return await http.get(this.url+id+'/',data);
		}
    },
    addImage:{
        url: `${config.API_URL}/siteImage/`,
		name: "添加场所图片",
		post: async function(id,data){
			return await http.post(this.url+id+'/',data);
		}
    },
    deleteImage:{
        url: `${config.API_URL}/siteImages/`,
		name: "删除场所图片",
		delete: async function(id,data){
			return await http.delete(this.url+id+'/',data);
		}
    },

    export:{
        url: `${config.API_URL}/exportSiteData`,
        name: "导出设备场所信息",
		get: async function(data){
			return await http.get(this.url, data);
		}
    },

	// 特定场所数量
	specialSiteNumber:{
		url: `${config.API_URL}/specialSiteNumber`,
		name:"查询特定数量企业(仪征市)",
		get:async function(data) {
			return await http.get(this.url,data)
		}
	},

	// 重点单位数量
	keySiteNumber:{
		url: `${config.API_URL}/keySiteNumber`,
		name:"重点场所(单位)数量(仪征市)",
		get:async function(data) {
			return await http.get(this.url,data)
		}
	},
	// 今日已处理报警数量
	todayHandledAlarmNumber:{
		url: `${config.API_URL}/todayHandledAlarmNumber`,
		name:"今日已处理报警数量(仪征市)",
		get:async function(data) {
			return await http.get(this.url,data)
		}
	}

}
